<div class="whiteListing section-pd">
    <div class="trinka_container container">
        <div class="row align-items-center" style="margin-bottom: 40px;">
            <div class="col-md-8 col-sm-8">
                <div class="trinka-title mb-0">
                    <h2>IP 白名單功能</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>IP 白名單機制可強化資料安全與系統管控，限制僅授權的 IP 存取 Trinka，有助於符合法規、提升安全性並節省資源。</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-4">
                <div class="benefitImage">
                    <img src="/assets/images/enterprise/the-benefit-whitepaper.webp" width="200" height="199" alt="The benefits" class="img-fluid" />
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-8 col-sm-12">
                <div class="trinka-title mb-0">
                    <h3 class="mb-2">功能特色</h3>
                    <p>IP 白名單機制可強化資料安全與系統管控，限制僅授權的 IP 存取 Trinka，有助於符合法規、提升安全性並節省資源。</p>
                </div>
            </div>
            
        </div>
        <div class="row match-box">
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>強化安全性 <span><img src="/assets/images/icons/cyber-security.png" width="70" height="70" alt="Enhanced security" /></span></h4>
                        <p>僅允許指定 IP 存取，降低未經授權的入侵風險與資安攻擊。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>降低停機風險 <span><img src="/assets/images/icons/browser.png" width="70" height="70" alt="Controlled Access" /></span></h4>
                        <p>避免因 DoS 攻擊或濫用造成的服務中斷。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>存取權限控管 <span><img src="/assets/images/icons/clock.png" width="70" height="70" alt="Reduced downtime" /></span></h4>
                        <p>管理者可精細控管哪些 IP 可連線，快速封鎖／開通存取權。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>符合法規要求 <span><img src="/assets/images/icons/growth.png" width="70" height="70" alt="Better compliance" /></span></h4>
                        <p>滿足多數行業對 IP 存取的合規性需求。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>